import { Injectable } from '@angular/core';

import { IntegrationsClientHttpBase } from '@core/integrations-http-legacy';

@Injectable({ providedIn: 'root' })
export class IntegrationsClientHttp extends IntegrationsClientHttpBase {
  public get baseUrl(): string {
    return this.config.integrationsUrl;
  }
}
